import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class TrainingService {
  public trainingRef: firebase.database.Reference;

  constructor(private db: AngularFireDatabase, private platform: Platform) {
    this.trainingRef = db.database.ref(`/com_shelcaster_training`);
  }

  getEvents() {
    return this.trainingRef.child('trainingevent');
  }

  getEvent(alias) {
    return this.trainingRef.child('trainingevent').child(`${alias}`);
  }

  getUserDetails(email) {
    return this.trainingRef.child('trainingattendee').child(`${email}`);
  }

  getCourseMaterials() {
    return this.trainingRef.child('trainingmaterial');
  }
}
